import { type ImageDTO } from '@capsicum/common';
import { type DESKTOP_TYPE_IMAGE, type MOBILE_TYPE_IMAGE, type SurveyMedia } from '@capsicum/features/survey/shared';
import { useCallback } from 'react';

import { getExtendedImagesData } from '../util';

type PollImagesTypes = typeof DESKTOP_TYPE_IMAGE | typeof MOBILE_TYPE_IMAGE;

type UsePollAnswersContentObject = {
	imageType: { type: string };
	url: string;
};

export const usePollPostTypesContent = () => {
	const getCorrectAnswerImages = useCallback(
		(images: Array<UsePollAnswersContentObject>, targetType: PollImagesTypes) => {
			if (!images) return [];

			const sortedImages = images
				.filter(image => image.imageType.type.includes(targetType))
				.sort((a, b) => (a.imageType.type > b.imageType.type ? 1 : -1));

			const sortedImagesWithThumbnail = getExtendedImagesData(sortedImages as unknown as Array<ImageDTO>);

			return (sortedImagesWithThumbnail as unknown as Array<SurveyMedia>) || [];
		},
		[]
	);

	return {
		getCorrectAnswerImages
	};
};
